/* TORRAS header behaviour.
 *
 * This was a 40 KB inline <script> in sections/torras-header.liquid. Inline section
 * JS ships with the HTML on EVERY page view and can never be cached — measured on
 * the live PDP it cost 10.1 KB brotli per view, forever. As an asset it is fetched
 * once and served immutable after that.
 *
 * It carried exactly one Liquid value — section.id, used only to find the root — so
 * the root now advertises itself with [data-t-hdr-root] and this file is static JS.
 *
 * Re-entrancy matters: an inline section script re-executes when the Theme Editor
 * re-renders its section, an external one does not. Hence the shopify:section:load
 * hook plus the dataset guard, so customiser edits rewire the header exactly once.
 */
(function () {
  /* Guard on a WeakSet, not a data attribute. Horizon re-renders sections through
     idiomorph, which KEEPS the existing node but syncs its attributes from the
     server HTML — and the server never emits data-t-hdr-booted, so an attribute
     guard gets silently stripped while the listeners stay attached. The next
     shopify:section:load would then bind everything a second time and every click
     would fire twice (open+close = drawer appears dead). A WeakSet lives in JS and
     survives the morph. Verified: forcing a re-boot with the attribute guard broke
     the drawer; with this it does not. */
  var booted = new WeakSet();

  function boot(root) {
    if (!root || booted.has(root)) return;
    booted.add(root);
    root.dataset.tHdrBooted = '1';   /* debugging signal only — never the guard */

      var burger = root.querySelector('.t-hdr__burger');
      var nav = root.querySelector('.t-hdr__nav');
      var desktop = window.matchMedia('(min-width: 1000px)');

      // Hard floor for the drawer's scroll while a sub-page is open. The CSS
      // already sets `overflow:hidden` on the nav for this, but that only stops the
      // USER scrolling it — scrollTop stays writable, and both scrollIntoView() and
      // the UA's own focus-restore still move it. On iOS Safari the sub-panel is
      // position:fixed with a transformed ancestor, so WebKit degrades it into a box
      // that rides the nav's scroll: any stray scroll there carries the panel (and
      // its "‹ Back · ✕" header) off the top of the screen. Pinning scrollTop to 0
      // makes the panel's top edge the viewport's, whatever tried to move it.
      if (nav) {
        nav.addEventListener('scroll', function () {
          if (nav.scrollTop !== 0 && root.querySelector('.t-hdr__item.is-open')) nav.scrollTop = 0;
        }, { passive: true });
      }

      // Close any open second-order sub-panel — returns the drawer to its root
      // card list. (On mobile .is-open drives a slide-in sub-panel.)
      function closePanels() {
        root.querySelectorAll('.t-hdr__item.is-open').forEach(function (i) {
          i.classList.remove('is-open');
          var t = i.querySelector('.t-hdr__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
      /* iOS Safari ignores `overflow:hidden` on <body> — a drag anywhere over the
         drawer still scrolls the document underneath. That is what made the sub-page's
         "‹ Back · ✕" header disappear INTERMITTENTLY: the panel is position:fixed under
         a transformed ancestor, so WebKit degrades it into a box that rides the nav's
         scroll, and a document scroll carries the whole panel — header included — off
         the top of the screen. Whether the shopper happened to drag is precisely why it
         read as a random bug rather than a reproducible one.
         `position:fixed` is the lock iOS actually honours, and it is already this
         theme's convention: the cart drawer and search lock the same way, and both
         syncBar() and its MutationObserver further down are written expecting exactly
         this shape (`body.style.position === 'fixed'`). The drawer was the odd one out.
         Restoring the offset is mandatory — dropping it drops the shopper at the top of
         the page every time the menu closes. */
      var drawerScrollY = 0;
      function openDrawer() {
        drawerScrollY = window.scrollY || document.documentElement.scrollTop || 0;
        root.classList.add('is-drawer-open');
        var b = document.body.style;
        b.position = 'fixed';
        b.top = -drawerScrollY + 'px';
        b.left = '0';
        b.right = '0';
        b.width = '100%';
        b.overflow = 'hidden';
        if (burger) burger.setAttribute('aria-expanded', 'true');
      }
      function closeDrawer() {
        root.classList.remove('is-drawer-open');
        var b = document.body.style;
        var wasLocked = b.position === 'fixed';
        b.position = b.top = b.left = b.right = b.width = b.overflow = '';
        if (wasLocked) {
          /* Instant: base.css sets a global `scroll-behavior:smooth`, which would
             animate this restore and leave the page visibly gliding back after the
             drawer is already gone. */
          var prev = document.documentElement.style.scrollBehavior;
          document.documentElement.style.scrollBehavior = 'auto';
          window.scrollTo(0, drawerScrollY);
          document.documentElement.style.scrollBehavior = prev;
        }
        if (burger) burger.setAttribute('aria-expanded', 'false');
        closePanels();
      }

      if (burger) {
        burger.addEventListener('click', function () {
          root.classList.contains('is-drawer-open') ? closeDrawer() : openDrawer();
        });
      }
      // Delegated Back / Close / scrim handling. Delegation (vs. per-button
      // listeners) is why Back is now reliable: it survives the section
      // re-rendering (cart-drawer morphs rewrite this section's HTML), works no
      // matter which child of the button was tapped (svg path / label), and can't
      // be shadowed by a re-injected sub-header. .t-hdr__d-back → step back one
      // level; any .t-hdr__d-close (root or sub) / scrim → close the whole drawer.
      root.addEventListener('click', function (e) {
        if (e.target.closest('.t-hdr__d-back')) { closePanels(); return; }
        if (e.target.closest('.t-hdr__d-close') || e.target.closest('.t-hdr__scrim')) { closeDrawer(); }
      });

      // Acknowledge a tap that navigates. Nothing in this file closes the drawer
      // when a nav link is tapped — the click just hands off to the browser, and
      // the drawer stays put until the next document's response arrives. That
      // gap is dead air on touch (no :hover, and :active dies with the finger
      // lift), and measured rage clicks on .t-hdr-dev are people re-tapping
      // through it. Mark the row so CSS can hold it pressed + spinning; the
      // unload tears the state down for us.
      root.addEventListener('click', function (e) {
        if (desktop.matches) return;                 // drawer is mobile-only
        if (e.defaultPrevented) return;              // mega trigger opened a sub-panel
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; // opens a new tab
        var link = e.target.closest('.t-hdr__nav a[href]');
        if (!link) return;
        var href = link.getAttribute('href');
        // '#' is the unconfigured-link default and in-page anchors never unload.
        if (!href || href.charAt(0) === '#') return;
        if (link.hasAttribute('download')) return;
        var target = link.getAttribute('target');
        if (target && target !== '_self') return;    // this page stays where it is
        link.classList.add('is-navigating');
      });

      // Back-forward cache restores this DOM verbatim, spinner and all — the
      // navigation it belonged to is long finished, so clear it on restore.
      window.addEventListener('pageshow', function () {
        root.querySelectorAll('.is-navigating').forEach(function (el) {
          el.classList.remove('is-navigating');
        });
      });
      // Escape steps back out of a sub-panel first, then closes the drawer.
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (root.querySelector('.t-hdr__item.is-open')) closePanels();
        else closeDrawer();
      });

      // ── Mobile second-order pages ─────────────────────────────────────────────
      // Each category card's panel becomes a full-height sub-screen that slides in
      // from the right over the root list, with its own sticky "‹ Back · Title · ✕"
      // header (injected once below). Desktop is untouched — its CSS :hover mega
      // dropdown still runs and the click handler bails when desktop.matches.
      root.querySelectorAll('.t-hdr__item--mega').forEach(function (item) {
        var trigger = item.querySelector('.t-hdr__trigger');
        var panel = item.querySelector('.t-hdr__panel');
        if (!trigger || !panel) return;

        if (!panel.querySelector('.t-hdr__d-subhead')) {
          // Title = the primary label text only (exclude the "New!" accent span).
          var titleEl = trigger.querySelector('.t-hdr__label > span') || trigger.querySelector('.t-hdr__label');
          var label = '';
          if (titleEl) {
            label = (titleEl.childNodes[0] ? titleEl.childNodes[0].textContent : titleEl.textContent) || '';
            label = label.trim();
          }
          var head = document.createElement('div');
          head.className = 't-hdr__d-subhead';
          head.innerHTML =
            '<button type="button" class="t-hdr__d-back" aria-label="Back">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>' +
              '<span>Back</span>' +
            '</button>' +
            '<span class="t-hdr__d-subtitle"></span>' +
            '<button type="button" class="t-hdr__d-close t-hdr__d-close--sub" aria-label="Close menu">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>';
          head.querySelector('.t-hdr__d-subtitle').textContent = label;
          panel.insertBefore(head, panel.firstChild);
          // (Back / close are handled by the delegated root click listener above.)
        }

        trigger.addEventListener('click', function (e) {
          if (desktop.matches) return; // desktop = hover mega dropdown, no JS toggle
          e.preventDefault();
          closePanels();
          // Reset the drawer's own scroll before opening: on iOS Safari the
          // fixed sub-panel scrolls with the nav's content, so opening from a
          // scrolled drawer would leave the panel offset and the root list
          // showing beneath it (the CSS overflow-lock then keeps it there).
          if (nav) nav.scrollTop = 0;
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.scrollTop = 0;
          // The nav still holds keyboard focus on the trigger we just tapped, and
          // the trigger's row is still in the layout (the root list is hidden with
          // visibility, not display). Anything that scrolls it back into view drags
          // the degraded-fixed panel up with it and the sticky "‹ Back · ✕" header
          // leaves the viewport — which is exactly how a sub-page shows up with no
          // way out on an iPhone (Bing, 2026-09-19). Hand focus to Back instead:
          // preventScroll so the move itself can't cause the very scroll we're
          // avoiding, and it is where a screen reader should land anyway.
          var back = panel.querySelector('.t-hdr__d-back');
          if (back) { try { back.focus({ preventScroll: true }); } catch (err) { back.focus(); } }
        });
      });

      desktop.addEventListener('change', function () {
        closeDrawer();
        root.querySelectorAll('.t-hdr__panel-inner--v2').forEach(devselPlace);
      });

      // Reveal sticky (both modes): the header always starts in normal flow and
      // scrolls away with the page. Once the whole header container's bottom edge
      // passes the viewport top, re-pin it as a fixed bar that slides in from the
      // top; the spacer (CSS) reserves its height so the page doesn't jump. On
      // transparent pages this same pin also flips the overlay from transparent to
      // solid. The container stays the same height whether the bar is in flow or
      // fixed (spacer), so the trigger reads consistently before and after pinning.
      var bar = root.querySelector('.t-hdr__bar');
      var isTransparent = root.classList.contains('t-hdr--transparent');
      var isSticky = root.classList.contains('t-hdr--sticky');
      if (bar && (isSticky || isTransparent)) {
        var pinned = false;
        function syncBar() {
          // publish on <body> so the cross-container overlay rules (which target
          // <main>) and the spacer both resolve the live bar height
          document.body.style.setProperty('--t-hdr-bar-h', bar.offsetHeight + 'px');
          // While a dialog (cart drawer, search, …) holds a scroll-lock, the body is
          // body{position:fixed; top:-scrollY} — window.scrollY reads 0 and the bar's
          // geometry is transient. A ResizeObserver/resize firing mid-lock would then
          // measure the bar as "on screen" and wrongly DROP .is-pinned (the header then
          // vanishes after the drawer closes). Never re-decide the pin state while
          // locked; the MutationObserver below re-runs syncBar once the lock releases.
          if (document.body.style.position === 'fixed') return;
          var off = root.getBoundingClientRect().bottom <= 0;
          // Reconcile against the ACTUAL class, not a cached `pinned` flag. A cart
          // update re-renders this section (the cart drawer is hosted here) and the
          // morph rewrites the class attribute from server HTML — silently dropping
          // the runtime-only .is-pinned. A cached flag would still read "pinned" and
          // mask the re-pin, leaving the header stuck off-screen after the drawer
          // closes. Comparing to the DOM makes the pin state self-healing.
          if (root.classList.contains('is-pinned') !== off) {
            pinned = off;
            root.classList.toggle('is-pinned', off);
          }
        }
        syncBar();
        window.addEventListener('scroll', syncBar, { passive: true });
        window.addEventListener('resize', syncBar);
        if (window.ResizeObserver) { new ResizeObserver(syncBar).observe(bar); }

        // Re-sync after a scroll-lock is released. Dialogs (cart drawer, search,
        // …) lock scrolling with body{position:fixed; top:-scrollY} and restore it
        // on close via scrollTo. That restore races the scroll-driven pin logic
        // above and can leave the bar wrongly un-pinned — i.e. stuck in normal flow
        // scrolled off-screen, so the header vanishes after closing the drawer.
        // Watching body's inline style lets us re-run syncBar once scroll settles,
        // independent of which dialog locked it.
        if (window.MutationObserver) {
          var wasLocked = document.body.style.position === 'fixed';
          new MutationObserver(function () {
            var locked = document.body.style.position === 'fixed';
            if (wasLocked && !locked) {
              // Double rAF: let scrollTo + layout settle before measuring.
              requestAnimationFrame(function () { requestAnimationFrame(syncBar); });
            }
            wasLocked = locked;
          }).observe(document.body, { attributes: true, attributeFilter: ['style'] });
        }
      }

      // ── Showroom Glass: sliding nav indicator ──────────────────────────────
      // One 2px orange bar for the whole nav instead of a per-item underline —
      // same slider language as the on-page anchor nav. It's absolutely
      // positioned against .t-hdr__bar (the nav stays static so mega panels keep
      // spanning the full bar), so both rects are read in viewport coordinates
      // and subtracted; that stays correct whether the bar is in flow or fixed.
      var ind = root.querySelector('.t-hdr__ind');
      var navEl = root.querySelector('.t-hdr__nav');
      if (ind && navEl && bar) {
        var indCurrent = null;
        var LINK_SEL = '.t-hdr__trigger, .t-hdr__plain';
        // Matches the showroom link padding, so the indicator hugs the label
        // rather than the padded hit area (which is 44px+ wide for touch).
        var IND_INSET = 14;

        // No top-level nav item is marked as the current page server-side, and a
        // cart re-render morphs the nav from server HTML anyway — so resolve it
        // from the URL each time rather than trusting a class to survive.
        function indFindCurrent() {
          var here = location.pathname.replace(/\/+$/, '') || '/';
          var best = null;
          var bestLen = 0;
          navEl.querySelectorAll('a.t-hdr__trigger, a.t-hdr__plain').forEach(function (a) {
            var p = (a.pathname || '').replace(/\/+$/, '');
            if (!p) return; // site root would match every page
            if (here === p || here.indexOf(p + '/') === 0) {
              if (p.length > bestLen) { best = a; bestLen = p.length; }
            }
          });
          navEl.querySelectorAll('.is-current').forEach(function (el) {
            if (el !== best) { el.classList.remove('is-current'); el.removeAttribute('aria-current'); }
          });
          if (best) { best.classList.add('is-current'); best.setAttribute('aria-current', 'page'); }
          indCurrent = best;
          return best;
        }

        function indSeat(el, instant) {
          if (!el || window.innerWidth < 1000) { ind.style.opacity = '0'; return; }
          var b = bar.getBoundingClientRect();
          var r = el.getBoundingClientRect();
          if (!r.width) { ind.style.opacity = '0'; return; }
          if (instant) ind.style.transition = 'none';
          ind.style.width = Math.max(r.width - IND_INSET * 2, 0) + 'px';
          ind.style.transform = 'translateX(' + (r.left - b.left + IND_INSET) + 'px)';
          ind.style.opacity = '1';
          if (instant) { void ind.offsetWidth; ind.style.transition = ''; }
        }

        navEl.addEventListener('pointerover', function (ev) {
          var el = ev.target.closest && ev.target.closest(LINK_SEL);
          // Links inside an open mega panel resolve to null here, so the
          // indicator stays parked on the trigger that opened it.
          if (el && navEl.contains(el)) indSeat(el);
        });
        navEl.addEventListener('focusin', function (ev) {
          var el = ev.target.closest && ev.target.closest(LINK_SEL);
          if (el && navEl.contains(el)) indSeat(el);
        });
        navEl.addEventListener('pointerleave', function () { indSeat(indFindCurrent()); });

        /* 🔴 鼠标离开导航后把焦点也带走，否则 mega 面板收不回去。
           桌面端 mega 是纯 CSS 开关，规则是 `:hover` **或** `:focus-within`
           （见 torras-header.liquid 的 .t-hdr__item--mega:focus-within .t-hdr__panel）。
           面板里的设备选择器是 <button data-tfs-open>，点完它焦点就停在面板内，
           于是 :focus-within 一直成立 —— 鼠标移到页面别处，面板也不收。
           那条既有的 `.t-hdr__nav:has(:hover)` 覆盖只解决了"焦点卡住 + 鼠标移到**另一个
           导航项**"，移到导航之外就不生效。2026-09-01 Bing 报的就是这个。

           只对鼠标负责：`:focus-visible` 命中说明是键盘导航，那种情况必须留着焦点
           （否则键盘用户 Tab 进面板会被立刻踢出去）。
           选择器弹层开着时也不动，免得把用户正在用的弹层关掉。
           pointerleave 按 DOM 包含判定，移进面板（面板是 nav 的后代）不会触发。 */
        navEl.addEventListener('pointerleave', function () {
          var ae = document.activeElement;
          if (!ae || !navEl.contains(ae) || ae === document.body) return;
          if (navEl.querySelector('[data-tfs-open][aria-expanded="true"]')) return;
          try { if (ae.matches(':focus-visible')) return; } catch (e) { /* 老浏览器无 :focus-visible，继续 blur */ }
          ae.blur();
        });

        var indReseat = function () { indSeat(indFindCurrent(), true); };
        indReseat();
        window.addEventListener('resize', indReseat);
        // FT Terra loads with font-display:swap — the fallback's metrics are wider,
        // so a seat measured before the swap lands is stale.
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(indReseat);
        window.addEventListener('load', indReseat);
      }

      // ── V2 mega panels: JS-built left rail ────────────────────────────────
      // Theme blocks can't be iterated twice in Liquid (content_for renders each
      // child once), so the rail is assembled here from each group's
      // data-rail-label. bootV2 is idempotent and re-runs after cart-drawer
      // morphs rewrite this section's HTML (observer below); events are
      // delegated from `root` so they survive the morph like the drawer's.
      function t2Select(inner, idx) {
        inner.querySelectorAll('.t2-rail__btn').forEach(function (b, k) { b.classList.toggle('is-on', k === idx); });
        inner.querySelectorAll('.t2-tabs__btn').forEach(function (b, k) { b.classList.toggle('is-on', k === idx); });
        inner.querySelectorAll('.t2-group').forEach(function (g, k) { g.classList.toggle('is-on', k === idx); });
        devselPlace(inner);
        // Desktop rail: vertical capsule glide.
        var on = inner.querySelector('.t2-rail__btn.is-on');
        var ind = inner.querySelector('.t2-rail__ind');
        if (on && ind && on.offsetParent) {
          ind.style.transform = 'translateY(' + on.offsetTop + 'px)';
          ind.style.height = on.offsetHeight + 'px';
        }
        // Mobile tabs: horizontal text-width underline glide + center the tab.
        var tab = inner.querySelector('.t2-tabs__btn.is-on');
        var tind = inner.querySelector('.t2-tabs__ind');
        if (tab && tind && tab.offsetParent) {
          tind.style.width = Math.max(tab.offsetWidth - 24, 0) + 'px';
          tind.style.transform = 'translateX(' + (tab.offsetLeft + 12) + 'px)';
          // Center the active tab by scrolling ONLY the tab row. Never
          // scrollIntoView here — it also scrolls every scrollable ancestor,
          // dragging the drawer container sideways at boot (content opened
          // half off-screen).
          var row = tab.parentNode;
          row.scrollTo({ left: Math.max(tab.offsetLeft - (row.clientWidth - tab.offsetWidth) / 2, 0), behavior: 'smooth' });
        }
      }
      function bootV2() {
        root.querySelectorAll('.t-hdr__panel-inner--v2').forEach(function (inner) {
          if (inner.querySelector('.t2-rail')) return;
          var groups = inner.querySelectorAll('.t2-group');
          if (!groups.length) return;
          // One group = nothing to switch between. Small categories (lens guards,
          // charging) render flat: no rail, no tabs, just the cards.
          if (groups.length < 2) {
            inner.classList.add('is-flat');
            groups[0].classList.add('is-on');
            return;
          }
          var rail = document.createElement('div');
          rail.className = 't2-rail';
          var ind = document.createElement('span');
          ind.className = 't2-rail__ind';
          ind.setAttribute('aria-hidden', 'true');
          rail.appendChild(ind);
          groups.forEach(function (g, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 't2-rail__btn';
            b.setAttribute('data-t2', i);
            b.appendChild(document.createTextNode(g.getAttribute('data-rail-label') || ''));
            var rb = g.getAttribute('data-rail-badge');
            if (rb) { var rbs = document.createElement('span'); rbs.className = 't2-rail__badge'; rbs.textContent = rb; b.appendChild(rbs); }
            rail.appendChild(b);
          });
          inner.insertBefore(rail, inner.firstChild);
          // Mobile sibling of the rail: one scrollable tab row built from the
          // same group labels, with a text-width underline indicator.
          var tabs = document.createElement('div');
          tabs.className = 't2-tabs';
          var tind = document.createElement('span');
          tind.className = 't2-tabs__ind';
          tind.setAttribute('aria-hidden', 'true');
          tabs.appendChild(tind);
          groups.forEach(function (g, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 't2-tabs__btn';
            b.setAttribute('data-t2', i);
            b.textContent = g.getAttribute('data-rail-label') || '';
            var tb = g.getAttribute('data-rail-badge');
            if (tb) { var tbs = document.createElement('span'); tbs.className = 't2-rail__badge'; tbs.textContent = tb; b.appendChild(tbs); }
            tabs.appendChild(b);
          });
          inner.insertBefore(tabs, rail);
          t2Select(inner, 0);
        });
      }
      bootV2();
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.t2-rail__btn, .t2-tabs__btn');
        if (!btn) return;
        t2Select(btn.closest('.t-hdr__panel-inner--v2'), +btn.getAttribute('data-t2'));
      });
      // Hover switches with a short intent delay so scrubbing past the rail
      // doesn't thrash groups. Desktop only — the rail is hidden in the drawer.
      var t2Intent = null;
      root.addEventListener('mouseover', function (e) {
        if (!desktop.matches) return;
        var btn = e.target.closest('.t2-rail__btn');
        if (!btn || btn.classList.contains('is-on')) return;
        clearTimeout(t2Intent);
        t2Intent = setTimeout(function () {
          if (btn.isConnected && btn.matches(':hover')) {
            t2Select(btn.closest('.t-hdr__panel-inner--v2'), +btn.getAttribute('data-t2'));
          }
        }, 60);
      });
      if (window.MutationObserver) {
        var t2Queued = false;
        new MutationObserver(function () {
          if (t2Queued) return;
          t2Queued = true;
          requestAnimationFrame(function () { t2Queued = false; bootV2(); bootDevSel(); });
        }).observe(root, { childList: true, subtree: true });
      }

      // ── Device select (.t2-devsel) ────────────────────────────────────────
      // The picker's markup is the PLP one (.tfs-*) and inherits its CSS; only the
      // model list is different. Theme blocks can't read each other's settings, so
      // the list is cloned from the rendered "By Device" panel named by
      // data-devsel-source — one merchant-edited list, reused by every panel.
      var DEVSEL_KEY = 'torras_gate_device';

      function devselSource(name) {
        var items = root.querySelectorAll('.t-hdr__item--mega');
        var want = (name || '').trim().toLowerCase();
        for (var i = 0; i < items.length; i++) {
          var lab = items[i].querySelector('.t-hdr__label > span');
          if (lab && lab.textContent.trim().toLowerCase() === want) return items[i];
        }
        return null;
      }

      // [{ brand, slug, models: [{ name, href }] }] harvested from the source panel.
      function devselHarvest(panel) {
        var out = [];
        panel.querySelectorAll('.t2-group').forEach(function (g) {
          var brand = (g.getAttribute('data-rail-label') || '').trim();
          var models = [];
          // A device model is a card with a model id. That's what separates the
          // brand groups from the panel's own product rows (Best Sellers), and it
          // drops legacy lump entries like "Pixel 9 series" now that the
          // individual models are listed.
          g.querySelectorAll('.t2-card[data-device-id]').forEach(function (card) {
            var nm = card.querySelector('.t2-card__nm');
            var name = (nm ? nm.textContent : card.textContent).trim();
            if (!name) return;
            models.push({
              name: name,
              href: card.getAttribute('href'),
              id: card.getAttribute('data-device-id') || ''
            });
          });
          if (brand && models.length) {
            out.push({ brand: brand, slug: brand.toLowerCase().replace(/[^a-z0-9]+/g, '-'), models: models });
          }
        });
        return out;
      }

      // Most device models have no collection of their own (only ~10 of 24 do), so
      // a pick lands on the panel's collection filtered to that model — the exact
      // link the collection page's picker builds. Falls back to the card's own
      // link when the picker has no base or the model carries no id.
      function devselHref(el, model) {
        var base = el.getAttribute('data-devsel-base');
        var param = el.getAttribute('data-devsel-param');
        if (base && param && model.id) {
          return base + (base.indexOf('?') === -1 ? '?' : '&') +
            encodeURIComponent(param) + '=' +
            encodeURIComponent('gid://shopify/Metaobject/' + model.id);
        }
        return model.href || '';
      }

      function devselRender(el, groups, allHref, allLabel) {
        var tabs = el.querySelector('[data-tfs-tabs]');
        var list = el.querySelector('[data-tfs-list]');
        if (!tabs || !list) return;
        var seoMap = {};
        try { seoMap = JSON.parse(el.getAttribute('data-devsel-map') || '{}') || {}; } catch (e) { seoMap = {}; }
        var saved = null;
        try { saved = localStorage.getItem(DEVSEL_KEY); } catch (e) {}
        // Only restore a model that's still in the list — the key is shared with
        // the rest of the site, and a stale or renamed model would otherwise sit
        // in the field forever with nothing behind it.
        if (saved) {
          var known = groups.some(function (g) {
            return g.models.some(function (m) { return m.name === saved; });
          });
          if (!known) {
            saved = null;
            try { localStorage.removeItem(DEVSEL_KEY); } catch (e) {}
          }
        }

        tabs.textContent = '';
        list.textContent = '';
        // Multi-brand only: a single-brand list needs no tab row.
        if (groups.length > 1) {
          groups.forEach(function (g, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'tfs-tab';
            b.setAttribute('role', 'tab');
            b.setAttribute('data-tfs-tab', g.slug);
            b.setAttribute('data-active', i === 0 ? 'true' : 'false');
            b.textContent = g.brand;
            tabs.appendChild(b);
          });
        }

        var all = document.createElement('a');
        all.className = 'tfs-item tfs-item--all';
        all.href = allHref || '#';
        all.setAttribute('data-name', 'all models');
        all.setAttribute('data-active', saved ? 'false' : 'true');
        all.innerHTML = '<span class="tfs-item-name">' + (allLabel || 'All models') + '</span><span class="tfs-item-meta"></span>';
        list.appendChild(all);

        groups.forEach(function (g, i) {
          var wrap = document.createElement('div');
          wrap.className = 'tfs-group';
          wrap.setAttribute('data-tfs-group', g.slug);
          if (groups.length > 1 && i !== 0) wrap.hidden = true;
          var head = document.createElement('div');
          head.className = 'tfs-ghead';
          head.textContent = g.brand;
          wrap.appendChild(head);
          // Long brand lists stay short: the first few models are the ones people
          // actually pick, the tail sits behind a View all row, and search reaches
          // everything either way.
          var cap = +(el.getAttribute('data-devsel-cap') || 4);
          g.models.forEach(function (m, mi) {
            var href = devselHref(el, m);
            if (!href) return;
            // Crawlable href: the device × category collection when the block's
            // data-devsel-map knows one, else the card's own (non-filter) link, else
            // the filter URL itself. The filter URL always survives in
            // data-filter-href; a plain click filters the panel in place regardless.
            var seo = seoMap[m.id] || ((m.href && m.href.indexOf('filter.') === -1) ? m.href : '');
            var a = document.createElement('a');
            a.className = 'tfs-item';
            a.href = seo || href;
            if (seo && seo !== href) a.setAttribute('data-filter-href', href);
            a.setAttribute('data-name', m.name.toLowerCase());
            a.setAttribute('data-device-model-id', m.id || '');
            a.setAttribute('data-active', saved === m.name ? 'true' : 'false');
            if (cap && mi >= cap) a.setAttribute('data-overflow', 'true');
            a.innerHTML = '<span class="tfs-item-name"></span><span class="tfs-item-meta"></span>';
            a.querySelector('.tfs-item-name').textContent = m.name;
            wrap.appendChild(a);
          });
          if (cap && g.models.length > cap) {
            var more = document.createElement('button');
            more.type = 'button';
            more.className = 'tfs-item tfs-more';
            more.setAttribute('data-tfs-more', '');
            more.innerHTML = '<span class="tfs-item-name">View all ' + g.models.length + ' ' + g.brand + ' models ›</span>';
            wrap.appendChild(more);
          }
          list.appendChild(wrap);
        });

        if (saved) devselLabel(el, saved);
        devselMarkStock(el);
      }

      // Which device-model ids this panel's cards collectively cover. null when
      // any card carries no data-fits: that card has no model data at all, and
      // "unknown" must not read as "doesn't fit" — a panel with model-less cards
      // makes no stock claims whatsoever.
      function devselStocked(el) {
        var grid = el.closest('.t-hdr__panel-inner--v2');
        if (!grid) return null;
        var cards = grid.querySelectorAll('.t2-card');
        if (!cards.length) return null;
        var stocked = null;
        for (var i = 0; i < cards.length; i++) {
          var f = cards[i].getAttribute('data-fits');
          if (!f) return null;
          if (!stocked) stocked = {};
          f.split(' ').forEach(function (x) { if (x) stocked[x] = 1; });
        }
        return stocked;
      }

      // Grey out models this panel sells nothing for, so the picker can't lead
      // into an empty result. (Whole brands with nothing are dropped earlier,
      // in bootDevSel — this handles the odd dead model inside a live brand.)
      function devselMarkStock(el) {
        var stocked = devselStocked(el);
        el.querySelectorAll('.tfs-item[data-device-model-id]').forEach(function (it) {
          var id = it.getAttribute('data-device-model-id');
          var dead = !!stocked && id && !stocked[id];
          it.setAttribute('data-disabled', dead ? 'true' : 'false');
          if (dead) it.setAttribute('aria-disabled', 'true');
          else it.removeAttribute('aria-disabled');
        });
      }

      // How many cards a V2 group paints. 4 = one desktop row (.t2-cards is a
      // 4-column grid). The matching no-JS/unfiltered rule lives in
      // torras-header.liquid — keep the two in step.
      var T2_ROW_CAP = 4;

      // Repaint one card's photo for a device pick. `src` blank (or no segment
      // image) restores the server-rendered face, which is captured on the first
      // swap so the markup stays the single source of the default.
      //
      // srcset is rebuilt from the swapped src rather than carried in data-swap:
      // every Shopify CDN url the card renders already ends in `width=<n>`, and
      // three widths per segment would triple an attribute the header ships on
      // every page. Keep the widths in step with torras-mega-card's image_tag.
      var T2_CARD_WIDTHS = [240, 320, 480];

      function t2CardSrcset(src) {
        if (!/[?&]width=\d+/.test(src)) return '';
        return T2_CARD_WIDTHS.map(function (w) {
          return src.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w';
        }).join(', ');
      }

      function t2CardPhoto(card, src) {
        var img = card.querySelector('.t2-card__well img');
        if (!img) return;
        if (!img.hasAttribute('data-home-src')) {
          img.setAttribute('data-home-src', img.getAttribute('src') || '');
          img.setAttribute('data-home-srcset', img.getAttribute('srcset') || '');
        }
        var next = src || img.getAttribute('data-home-src');
        if (!next || img.getAttribute('src') === next) return;
        img.setAttribute('src', next);
        var set = src ? t2CardSrcset(next) : img.getAttribute('data-home-srcset');
        if (set) img.setAttribute('srcset', set);
        else img.removeAttribute('srcset');
      }

      // Narrow the panel to one device model. A card declares the models it covers
      // in data-fits (metaobject ids, built in _t-mega-v2-product from the family's
      // custom.device_models); cards without the attribute — device tiles, or
      // products with no model data — are never filtered out, since "unknown" must
      // not read as "doesn't fit".
      function devselApply(el, id) {
        var grid = el.closest('.t-hdr__panel-inner--v2');
        if (!grid) return;
        grid.classList.toggle('is-filtered', !!id);
        el.classList.toggle('is-set', !!id);
        var model = (el.querySelector('[data-tfs-modelval]') || {}).textContent || '';
        grid.querySelectorAll('.t2-group').forEach(function (g) {
          g.setAttribute('data-empty-note', 'Nothing here fits the ' + model.trim() + ' yet.');
        });
        grid.querySelectorAll('.t2-group').forEach(function (g) {
          var shown = 0;
          g.querySelectorAll('.t2-card').forEach(function (card) {
            var fits = card.getAttribute('data-fits');
            var hide = !!id && fits && (' ' + fits + ' ').indexOf(' ' + id + ' ') === -1;
            card.classList.toggle('is-unfit', hide);
            if (!hide && !card.hasAttribute('hidden')) shown++;
            // Row cap (T2_ROW_CAP): paint at most one desktop row. Cards past
            // the cap are bench — they exist so a group can still fill its row
            // for a phone the earlier cards don't cover. Counted against
            // `shown`, the number of cards that FIT, not DOM position: on an
            // iPhone 17 Pro the Cases panel's Q group skips its 18-only card
            // and promotes a 17-only one into the freed slot.
            //
            // `shown` itself stays the true fit count — is-empty and the rail
            // dimming below key off it, and a group with 6 fitting cards is
            // very much not empty.
            card.classList.toggle('is-over', !hide && shown > T2_ROW_CAP);
            // Name-folded cards (collection mode) and any card whose family or
            // Device option covers more than one phone: retarget the card to the
            // product (or variant) matching the picked model — link AND photo
            // swap in place; a cleared pick restores the default face.
            //
            // The photo is not cosmetic. A segment's url alone left the card
            // linking to the iPhone 17 Pro product under an iPhone 18 Pro Max
            // render, which is what shoppers read as "the menu ignored my pick".
            var map = card.getAttribute('data-swap');
            if (map) {
              var target = null;
              if (id) {
                var segs = map.split(';');
                for (var si = 0; si < segs.length; si++) {
                  var parts = segs[si].split('|');
                  if ((' ' + (parts[1] || '') + ' ').indexOf(' ' + id + ' ') > -1) { target = parts; break; }
                }
              }
              var href = target ? target[0] : card.getAttribute('data-swap-home');
              if (href) card.setAttribute('href', href);
              // Skip cards this pick hides (is-unfit, and bench cards past the
              // row cap — both display:none): swapping them would fetch an image
              // nobody sees, and the next pick re-runs this whole loop before
              // any of them can come back.
              if (!hide && !card.classList.contains('is-over')) {
                t2CardPhoto(card, target ? target[2] : '');
              }
            }
          });
          g.classList.toggle('is-empty', !!id && shown === 0);
          g.setAttribute('data-fit-count', shown);
        });
        // A category with nothing for this phone dims in the rail AND stops being
        // clickable — the state, not a count: a number reads as noise next to a
        // one-word label, and a live button that opens an empty pane is a lie.
        var groups = grid.querySelectorAll('.t2-group');
        grid.querySelectorAll('.t2-rail__btn, .t2-tabs__btn').forEach(function (btn) {
          var g = groups[+btn.getAttribute('data-t2')];
          if (!g) return;
          var dead = !!id && g.classList.contains('is-empty');
          btn.classList.toggle('is-empty', dead);
          btn.disabled = dead;
          btn.setAttribute('aria-disabled', dead ? 'true' : 'false');
        });

        // Never leave the user parked on an empty category when another one has
        // something for their phone.
        var live = [];
        groups.forEach(function (g, i) { if (!g.classList.contains('is-empty')) live.push(i); });
        grid.classList.toggle('is-void', !!id && live.length === 0);
        if (id && live.length) {
          var onIdx = -1;
          groups.forEach(function (g, i) { if (g.classList.contains('is-on')) onIdx = i; });
          if (onIdx === -1 || live.indexOf(onIdx) === -1) t2Select(grid, live[0]);
        }

        // Re-seat the tab underline / rail capsule: hiding empty tabs (mobile)
        // shifts every remaining button's offsets, so re-run the selection
        // measurement for whichever group is current.
        var onIdx2 = -1;
        groups.forEach(function (g, i) { if (g.classList.contains('is-on')) onIdx2 = i; });
        if (onIdx2 > -1) t2Select(grid, onIdx2);

        // Whole panel empty: say it plainly rather than showing an empty shelf.
        var void_ = grid.querySelector('.t2-void');
        if (!void_) {
          void_ = document.createElement('p');
          void_.className = 't2-void';
          grid.appendChild(void_);
        }
        void_.textContent = id
          ? 'Nothing here fits the ' + model.trim() + ' yet — pick another model, or show all.'
          : '';
      }

      function devselLabel(el, value) {
        var val = el.querySelector('[data-tfs-modelval]');
        if (val) val.textContent = value || el.getAttribute('data-devsel-all') || 'Choose your device';
        el.classList.toggle('is-set', !!value);
      }

      // Desktop: the device select is the FIRST item inside the rail — part of
      // the L2 column, above the group buttons. Mobile puts it back as a panel
      // child so the drawer's order:-1 top placement applies. The moved node is
      // the shopify-block WRAPPER (display: contents) so the theme editor's
      // block mapping stays intact. Must run BEFORE the rail indicator is
      // measured — it changes every button's offsetTop.
      function devselPlace(inner) {
        var el = inner.querySelector('.t2-devsel');
        if (!el) return;
        var node = el.parentElement;
        if (!node || !(node.matches && node.matches('shopify-block, .shopify-block'))) node = el;
        if (!desktop.matches) {
          if (node.parentNode !== inner) inner.appendChild(node);
          return;
        }
        var rail = inner.querySelector('.t2-rail');
        if (rail) {
          var first = rail.querySelector('.t2-rail__btn');
          if (node.parentNode !== rail || (first && node.nextElementSibling !== first)) {
            rail.insertBefore(node, first || null);
          }
        } else if (node.parentNode !== inner) {
          inner.appendChild(node);
        }
      }

      function bootDevSel() {
        root.querySelectorAll('[data-devsel]').forEach(function (el) {
          // Flag the grid so the rail/cards/strip can drop a row — see the CSS
          // note: the shopify-block wrapper makes a `:has(> …)` rule impossible.
          var grid = el.closest('.t-hdr__panel-inner--v2');
          if (grid) grid.classList.add('has-devsel');
          var panel = devselSource(el.getAttribute('data-devsel-source'));
          if (!panel) return;
          var groups = devselHarvest(panel);
          // A brand this panel stocks nothing for has no business as a tab —
          // the Cases panel only ships iPhone cases, so Samsung/Pixel tabs
          // would only lead to fully greyed lists. Down to one brand, the
          // render skips the tab row entirely. A model without an id can't be
          // claimed dead, so it keeps its brand alive (same fail-open rule as
          // devselMarkStock).
          var stocked = devselStocked(el);
          if (stocked) {
            groups = groups.filter(function (g) {
              return g.models.some(function (m) { return !m.id || stocked[m.id]; });
            });
          }
          if (!groups.length) return;
          // Re-render only when the source list actually changed (cart morph
          // rewrites the header wholesale and this runs again).
          var sig = groups.map(function (g) { return g.slug + ':' + g.models.length; }).join('|');
          if (el.getAttribute('data-devsel-sig') === sig) return;
          el.setAttribute('data-devsel-sig', sig);
          var trigger = panel.querySelector('.t-hdr__trigger');
          devselRender(el, groups, trigger ? trigger.getAttribute('href') : null, 'All models');
          // Restore the remembered model: the field label is set inside render,
          // this puts the cards in the matching state.
          var active = el.querySelector('.tfs-item[data-active="true"][data-device-model-id]');
          devselApply(el, active ? active.getAttribute('data-device-model-id') : '');
        });
      }
      bootDevSel();

      // 面板下拉不能越出 mega 面板的底边（实测 1440×900 溢出 110px）。
      // mega 面板高度随内容变，CSS 里量不到，所以开的时候按实测空间给一个上限；
      // 变量没设时 CSS 回落到原来的 min(52vh, 24rem)，行为与改动前一致。
      function devselFit(el) {
        var r = el.querySelector('[data-tfs-root]');
        if (!r) return;
        r.style.removeProperty('--t2-devsel-maxh');
        if (!desktop.matches) return;              // 移动端是底部抽屉，另一套定位
        var panel = el.closest('.t-hdr__panel');
        if (!panel) return;                        // 不在 mega 面板里就不限制
        var btn = el.querySelector('[data-tfs-open]');
        if (!btn) return;
        var top = btn.getBoundingClientRect().bottom + 8;   // CSS: top calc(100% + 8px)
        var avail = panel.getBoundingClientRect().bottom - top - 12;  // 12 = 底部留白
        // 面板再矮也留 208px（搜索框 + 品牌页签 + 3 行），宁可轻微出界也不给一个点不动的下拉。
        r.style.setProperty('--t2-devsel-maxh', Math.max(Math.floor(avail), 208) + 'px');
      }

      // 自绘滚动条。系统滚动条在 macOS 的自动隐藏设置下是 overlay，静止时一点痕迹都没有
      // （实测 overflow-y:scroll 与自定义 ::-webkit-scrollbar 都不占位），限高之后就看不出
      // 下面还有二十几个机型。thumb 是 .tfs-panel::after，这里只写变量、不动 DOM。
      function devselScrollbar(el) {
        var r = el.querySelector('[data-tfs-root]');
        var panel = el.querySelector('.tfs-panel');
        var list = el.querySelector('[data-tfs-list]');
        if (!r || !panel || !list) return;

        function paint() {
          // 移动端是整屏抽屉、本来就不限高，交给系统的惯性滚动，别在上面画第二条。
          if (!desktop.matches) {
            r.classList.remove('is-scrollable');
            panel.style.setProperty('--t2-sb-on', '0');
            return;
          }
          var over = list.scrollHeight - list.clientHeight;
          if (over <= 2) {                       // 内容装得下就不画
            r.classList.remove('is-scrollable');
            panel.style.setProperty('--t2-sb-on', '0');
            return;
          }
          r.classList.add('is-scrollable');
          var pr = panel.getBoundingClientRect();
          var lr = list.getBoundingClientRect();
          var trackTop = lr.top - pr.top + 4;
          var trackH = lr.height - 8;
          var thumbH = Math.max(24, Math.round(trackH * (list.clientHeight / list.scrollHeight)));
          var y = Math.round((trackH - thumbH) * (list.scrollTop / over));
          panel.style.setProperty('--t2-sb-top', Math.round(trackTop) + y + 'px');
          panel.style.setProperty('--t2-sb-h', thumbH + 'px');
          panel.style.setProperty('--t2-sb-on', '1');
        }

        if (!list.__t2sb) {
          list.__t2sb = true;
          list.addEventListener('scroll', paint, { passive: true });
        }
        list.__t2sbPaint = paint;
        paint();
      }

      // 搜索、切品牌页签、展开 View all 都会换掉列表内容 —— 长度变了就得重画。
      function devselRepaint(el) {
        var list = el && el.querySelector('[data-tfs-list]');
        if (list && list.__t2sbPaint) requestAnimationFrame(list.__t2sbPaint);
      }

      function devselClose(el) {
        var r = el.querySelector('[data-tfs-root]');
        if (r) r.classList.remove('is-open');
        var b = el.querySelector('[data-tfs-open]');
        if (b) b.setAttribute('aria-expanded', 'false');
      }

      // Moving to another nav item closes any open picker — the panels swap on
      // :hover, so without this the picker is still hanging open when the user
      // hovers back to the panel that owns it.
      root.addEventListener('mouseover', function (e) {
        var mi = e.target.closest('.t-hdr__item');
        if (!mi) return;
        root.querySelectorAll('[data-devsel]').forEach(function (el) {
          if (!mi.contains(el)) devselClose(el);
        });
      });

      root.addEventListener('click', function (e) {
        var open = e.target.closest('[data-tfs-open]');
        if (open) {
          var el = open.closest('[data-devsel]');
          var r = el.querySelector('[data-tfs-root]');
          var willOpen = !r.classList.contains('is-open');
          root.querySelectorAll('[data-devsel]').forEach(devselClose);
          if (willOpen) {
            r.classList.add('is-open');
            devselFit(el);
            open.setAttribute('aria-expanded', 'true');
            requestAnimationFrame(function () { devselScrollbar(el); });
            var s = el.querySelector('[data-tfs-search]');
            if (s && desktop.matches) setTimeout(function () { s.focus(); }, 30);
          }
          return;
        }
        if (e.target.closest('[data-tfs-close]')) {
          devselClose(e.target.closest('[data-devsel]'));
          return;
        }
        var more = e.target.closest('[data-tfs-more]');
        if (more) {
          more.closest('[data-tfs-group]').querySelectorAll('[data-overflow]').forEach(function (i) {
            i.removeAttribute('data-overflow');
          });
          more.remove();
          devselRepaint(e.target.closest('[data-devsel]'));
          return;
        }
        var tab = e.target.closest('[data-tfs-tab]');
        if (tab) {
          var host = tab.closest('[data-devsel]');
          var slug = tab.getAttribute('data-tfs-tab');
          host.querySelectorAll('[data-tfs-tab]').forEach(function (t) {
            t.setAttribute('data-active', t.getAttribute('data-tfs-tab') === slug ? 'true' : 'false');
          });
          host.querySelectorAll('[data-tfs-group]').forEach(function (g) {
            g.hidden = g.getAttribute('data-tfs-group') !== slug;
          });
          devselRepaint(host);
          return;
        }
        var item = e.target.closest('.tfs-item');
        if (item && item.closest('[data-devsel]')) {
          // Filtering happens in the panel — the href stays on the element as the
          // no-JS fallback and as the "open the filtered collection" escape, but a
          // plain click narrows the cards in place instead of navigating away.
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.which === 2) return;
          e.preventDefault();
          var host = item.closest('[data-devsel]');
          var isAll = item.classList.contains('tfs-item--all');
          var pick = isAll ? null : {
            id: item.getAttribute('data-device-model-id') || '',
            name: ((item.querySelector('.tfs-item-name') || {}).textContent || '').trim()
          };
          try {
            if (pick && pick.name) localStorage.setItem(DEVSEL_KEY, pick.name);
            else localStorage.removeItem(DEVSEL_KEY);
          } catch (err) {}
          host.querySelectorAll('.tfs-item').forEach(function (i) {
            i.setAttribute('data-active', i === item ? 'true' : 'false');
            if (i === item) i.setAttribute('aria-current', 'true');
            else i.removeAttribute('aria-current');
          });
          devselLabel(host, pick ? pick.name : '');
          devselApply(host, pick ? pick.id : '');
          devselClose(host);
          return;
        }
        // Click outside any picker closes them.
        if (!e.target.closest('[data-devsel]')) root.querySelectorAll('[data-devsel]').forEach(devselClose);
      });

      root.addEventListener('input', function (e) {
        var input = e.target.closest('[data-tfs-search]');
        if (!input) return;
        var el = input.closest('[data-devsel]');
        var q = input.value.trim().toLowerCase();
        var hits = 0;
        el.querySelectorAll('.tfs-item').forEach(function (it) {
          if (it.classList.contains('tfs-item--all')) {
            it.hidden = !!q;
            return;
          }
          var hit = !q || (it.getAttribute('data-name') || '').indexOf(q) !== -1;
          it.hidden = !hit;
          if (hit) hits++;
        });
        // While searching, every group is visible so a match in a background brand
        // isn't hidden by the active tab; clearing restores tab filtering.
        var active = el.querySelector('[data-tfs-tab][data-active="true"]');
        el.querySelectorAll('[data-tfs-group]').forEach(function (g) {
          if (q) g.hidden = g.querySelectorAll('.tfs-item:not([hidden])').length === 0;
          else g.hidden = !!active && g.getAttribute('data-tfs-group') !== active.getAttribute('data-tfs-tab');
        });
        var empty = el.querySelector('[data-tfs-empty]');
        if (empty) empty.setAttribute('data-show', q && hits === 0 ? 'true' : 'false');
        devselRepaint(el);
      });

      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        root.querySelectorAll('[data-devsel]').forEach(devselClose);
      });

      // ── Debug helper ──────────────────────────────────────────────────────
      // Desktop mega panels open purely on CSS :hover, so you can't inspect them
      // in devtools (moving the mouse to the console collapses them). Call
      // window.debugMenu(n) to force the n-th mega item open (1-based, matching
      // nav order); debugMenu(0) / debugMenu() closes all. Returns the label.
      window.debugMenu = function (n) {
        var items = root.querySelectorAll('.t-hdr__item--mega');
        items.forEach(function (it) { it.classList.remove('is-debug-open'); });
        if (!n) { console.log('[debugMenu] closed all (' + items.length + ' mega items)'); return null; }
        var el = items[n - 1];
        if (!el) {
          console.warn('[debugMenu] no mega item #' + n + ' — only ' + items.length + ' exist (1–' + items.length + ')');
          return null;
        }
        el.classList.add('is-debug-open');
        var t = el.querySelector('.t-hdr__trigger');
        var label = t ? t.textContent.trim() : '';
        console.log('[debugMenu] opened #' + n + ' → "' + label + '"  (debugMenu(0) to close)');
        return label;
      };
  }

  /* ── Cart truth: the badge's label, and a page restored from the bfcache ──────
     Two things nothing else on the page owns. Both measured 2026-10-05.

     1. The badge's accessible name. `aria-label="Cart (N)"` is server-rendered on
        the cart button, which sits OUTSIDE the drawer's data-hydration-key subtree,
        so the morph that follows a cart change never rewrites it. cart-icon.js
        keeps the visible bubble right; a screen reader went on hearing the count
        from page load ("Cart (2)" over a bubble showing 1).

     2. A document restored from the back/forward cache. The DOM comes back
        verbatim, cart included. cart-icon.js corrects the bubble only when the
        change is under 10 s old and nothing refreshes the drawer's contents — a
        shopper who added six items across PDPs, pressed Back and opened the cart
        was told "Your cart is empty". On restore, ask /cart.js; if it disagrees
        with what this document last saw, say so through the theme's own
        cart:update, so every listener (drawer, bubble, kit rail, offer bars)
        redraws exactly as it does after an add.

     Document-level and outside boot() on purpose: the Theme Editor can re-boot the
     header, these listeners must exist once. */
  var CART_RESYNC = 'torras-cart-resync';
  var knownCart = null;          /* { count, total } as this document last saw it */
  var learnTimer = 0;

  function cartUrl() {
    var routes = window.Shopify && window.Shopify.routes;
    return ((routes && routes.root) || '/') + 'cart.js';
  }

  function fetchCart() {
    return fetch(cartUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) { return cart && typeof cart.item_count === 'number' ? cart : null; })
      .catch(function () { return null; });   /* offline / throttled — the next cart:update retries */
  }

  /** The count Liquid rendered into the label, or null when there is no badge. */
  function badgeCount() {
    var badge = document.querySelector('.t-hdr__cart-badge[aria-label]');
    var m = badge && /\((\d+)\)\s*$/.exec(badge.getAttribute('aria-label'));
    return m ? parseInt(m[1], 10) : null;
  }

  /* Only the trailing "(N)" is rewritten: the word in front is the translated
     `accessibility.cart` string and stays whatever Liquid rendered. */
  function noteCart(cart) {
    knownCart = { count: cart.item_count, total: cart.total_price };
    document.querySelectorAll('.t-hdr__cart-badge[aria-label]').forEach(function (badge) {
      var label = badge.getAttribute('aria-label');
      var next = label.replace(/\(\d+\)\s*$/, '(' + cart.item_count + ')');
      if (next !== label) badge.setAttribute('aria-label', next);
    });
  }

  document.addEventListener('cart:update', function (event) {
    var detail = event.detail || {};
    if (detail.data && detail.data.didError) return;
    var cart = detail.resource;
    if (cart && typeof cart.item_count === 'number') { noteCart(cart); return; }
    /* A producer that hands over no cart. Its data.itemCount is no substitute —
       product-form sends the quantity just added, not the total — so ask once the
       burst has settled. */
    clearTimeout(learnTimer);
    learnTimer = setTimeout(function () {
      fetchCart().then(function (fresh) { if (fresh) noteCart(fresh); });
    }, 400);
  });

  /* 🔴 Horizon gives CartAddEvent and CartUpdateEvent the SAME event name, so the
     drawer's add handler — which opens it whenever the component carries
     `auto-open` — runs for every cart:update, this one included. A drawer that
     throws itself open because the shopper pressed Back reads as broken. Same cure
     as announce() in assets/torras-free-gift.js: the attribute comes off for the
     length of one synchronous dispatch and goes straight back. */
  function announceQuietly(cart) {
    var event = new Event('cart:update', { bubbles: true });
    event.detail = {
      resource: cart,
      sourceId: CART_RESYNC,
      /* No `sections`: cart-items-component then re-renders its own section. */
      data: { source: CART_RESYNC, itemCount: cart.item_count }
    };
    var drawers = document.querySelectorAll('cart-drawer-component[auto-open]');
    drawers.forEach(function (drawer) { drawer.removeAttribute('auto-open'); });
    try {
      document.dispatchEvent(event);
    } finally {
      drawers.forEach(function (drawer) { drawer.setAttribute('auto-open', ''); });
    }
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;          /* a fresh load already has the server's cart */
    fetchCart().then(function (cart) {
      if (!cart) return;
      var seen = knownCart || { count: badgeCount(), total: null };
      /* Total unknown (no cart event on this document yet): only an empty cart can
         be called unchanged on the count alone — the same count can hide a swap. */
      var unchanged = seen.count === cart.item_count &&
        (seen.total === null ? cart.item_count === 0 : seen.total === cart.total_price);
      if (!unchanged) announceQuietly(cart);
    });
  });

  function bootAll() {
    document.querySelectorAll('[data-t-hdr-root]').forEach(boot);
  }

  /* Boot as early as the DOM allows, and be indifferent to when this file lands.
     The <script> tag sits AFTER the header markup and is `async`, so in the normal
     case the header already exists the moment this runs and the first bootAll()
     wires it immediately. The readyState fallback only matters if the file is
     somehow evaluated before its own markup (e.g. moved to <head> later).

     It used to be `defer`, which does not execute until the WHOLE document is
     parsed — on a 832 KB PDP that left the burger dead for a long, visible window.
     Inline script (what this replaced) ran the instant the header markup closed;
     async + preload gets back to roughly that, without the per-view byte cost. */
  bootAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll, { once: true });
  }
  document.addEventListener('shopify:section:load', bootAll);
})();
